import {Link} from "react-router-dom";
import setTitleAndMetaDescription from "../../../components/setTitleAndMetaDescription.tsx";
import Icon from "../../../components/selfcare/Icon.tsx";
import {Release} from "../releases.ts";
import ScrollToTop from "../../../components/ScrollToTop.tsx";
import setOGImageMeta from "../../../components/setOGImageMeta.tsx";
import IconArrow from "../../../components/icons/IconArrow.tsx";

export default function PressReleaseLayout(props: { release: Release }) {
    ScrollToTop()

    setTitleAndMetaDescription("Presse - " + props.release.title, props.release.description)
    setOGImageMeta(props.release.img_list)

    return (
        <>
            <section className="header">
                <p className="heading heading--big">
                    Pressemeddelelse
                </p>
                <p>
                    <Link to="/presse" className="icon-link icon-link-left icon-link-rotate-180 back-link-widget %s">
                        <Icon component={IconArrow}/> <span className="text">Tilbage</span>
                    </Link>
                </p>
            </section>
            <section>
                <div className="content content--narrow">
                    <div className="blurb">
                        <h1 className="heading heading--montserrat heading--big">
                            {props.release.heading}
                            <span className="heading__title">København {props.release.date_human}</span>
                        </h1>
                    </div>
                    <p><strong>{props.release.subheading}</strong></p>
                    {props.release.content !== undefined && <props.release.content/>}
                    <p>
                        <strong>Kontakt</strong><br/>
                        Mikkel Riis-Jørgensen<br/>
                        Pressechef, Nuuday<br/>
                        <a href="mailto:mikri@nuuday.dk">mikri@nuuday.dk</a><br/>
                        <a href="tel:+4520771281">2077 1281</a>
                    </p>
                </div>
            </section>
        </>
    )
}
